<template>
  <nav class="header-nav">
    <div class="nav-block"></div>
    <div class="header-nav__end">
      <div class="nav-block">
        <router-link class="header-nav__link" to="/stories">
          Your stories
        </router-link>
        <router-link class="header-nav__link" to="/our-impact">
          Our impact
        </router-link>
        <router-link class="header-nav__link" to="/raffle-silent-auction">
          Raffle & Silent Auction
        </router-link>
        <a class="header-nav__link" v-if="currentUser" @click="logout"
          >Logout</a
        >
      </div>
      <v-btn
        class="ml-8 gift-btn elevation-0"
        color="primary"
        href="https://tour.givesmart.com"
        target="_blank"
      >
        <v-icon>$gift</v-icon>
        <span>
          Donate
        </span>
      </v-btn>
    </div>
  </nav>
</template>

<script>
export default {
  name: "HeaderNav",
  data() {
    return {
      signInModal: false,
    };
  },
  methods: {
    logout() {
      this.$store.dispatch("auth/logout");
    },
    openAuthModal() {
      this.$root.$emit("auth");
    },
  },
};
</script>

<style scoped lang="scss">
.header-nav {
  white-space: nowrap;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 10px;

  &__end {
    display: flex;
    align-items: center;
  }

  &__link {
    display: inline-block;
    margin-left: 35px;
    font-style: normal;
    font-size: 20px;
    font-weight: normal;
    text-transform: uppercase;
    color: white;
    text-decoration: none;
    transition: 0.3s;
    font-family: "Roboto Condensed", sans-serif;
    border-bottom: 2px solid transparent;

    &.router-link-active {
      border-color: $primary;
    }

    &:not(.router-link-active):hover {
      color: $primary;
    }
  }
}

.header-nav::v-deep {
  .v-btn {
    font-size: 18px;
    line-height: 16px;
    letter-spacing: 0;
  }
}

@media screen and (max-width: 1264px) {
  .header-nav__link {
    margin-left: 20px;
  }
}

@media screen and (max-width: 960px) {
  .nav-block {
    display: none !important;
  }

  .header-nav__end {
    width: 100%;
    justify-content: flex-end;
  }
  .ml-8.gift-btn {
    margin-left: 0 !important;
  }
}
</style>
